import { useEffect, useState } from 'react';
import { getMyPayslip } from '../api/payroll';
import { fmtVND } from '../utils/format';

// Vòng tròn KPI (donut SVG thuần). p = 0..100.
function Donut({ p }) {
  const R = 52, C = 2 * Math.PI * R;
  const pct = Math.max(0, Math.min(100, Number(p) || 0));
  const off = C * (1 - pct / 100);
  return (
    <svg width="128" height="128" viewBox="0 0 128 128" className="mbkpi-donut">
      <circle cx="64" cy="64" r={R} fill="none" stroke="var(--track)" strokeWidth="12" />
      <circle cx="64" cy="64" r={R} fill="none" stroke="var(--accent)" strokeWidth="12" strokeLinecap="round"
        strokeDasharray={C} strokeDashoffset={off} transform="rotate(-90 64 64)" />
      <text x="64" y="64" textAnchor="middle" dominantBaseline="central" className="mbkpi-donut-txt">{Math.round(pct)}%</text>
    </svg>
  );
}

// Màn KPI & Lương (mobile) — bản CÁ NHÂN theo thiết kế: donut % + thống kê việc + thẻ lương tháng.
// myRow: dòng KPI của chính mình (từ kpiBoard). onOpenSalary: mở tab Bảng lương (phiếu lương chi tiết).
export default function MobileKpi({ me, myRow, month, onOpenSalary }) {
  const [pay, setPay] = useState(null);
  const monthLabel = month || (() => { const d = new Date(); return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`; })();
  useEffect(() => {
    let alive = true;
    getMyPayslip(month || undefined).then((d) => alive && setPay(d)).catch(() => alive && setPay(null));
    return () => { alive = false; };
  }, [month]);

  const total = myRow?.totalTasks || 0;
  const late = myRow?.lateCount || 0;
  const done = Math.max(0, total - late);
  const pct = myRow?.onTimeRate || 0;
  const mLabel = `${Number(monthLabel.slice(5, 7))}/${monthLabel.slice(0, 4)}`;
  // Hoa hồng = lương kinh doanh (MH+VC) hoặc vượt khoán (OP).
  const commission = pay ? (pay.department === 'Phòng OP' ? (pay.overQuotaPay || 0) : (pay.kinhDoanhMH || 0) + (pay.kinhDoanhVC || 0)) : 0;

  return (
    <div className="mbkpi">
      {/* KPI tháng */}
      <div className="card mbkpi-card">
        <div className="mbkpi-card-title">KPI tháng</div>
        <div className="mbkpi-kpirow">
          <Donut p={pct} />
          <div className="mbkpi-stats">
            <div className="mbkpi-stat" style={{ '--c': 'var(--accent)' }}>
              <div><b>{total}</b> việc</div><div className="mbkpi-stat-lb">Tổng công việc</div>
            </div>
            <div className="mbkpi-stat" style={{ '--c': 'var(--ok)' }}>
              <div><b style={{ color: 'var(--ok)' }}>{done}</b> việc</div><div className="mbkpi-stat-lb">Hoàn thành</div>
            </div>
            <div className="mbkpi-stat" style={{ '--c': 'var(--danger)' }}>
              <div><b style={{ color: 'var(--danger)' }}>{late}</b> việc</div><div className="mbkpi-stat-lb">Trễ hạn</div>
            </div>
          </div>
        </div>
      </div>

      {/* Lương tháng */}
      <div className="card mbkpi-card">
        <div className="row between" style={{ alignItems: 'flex-start' }}>
          <div>
            <div className="mbkpi-card-title">Lương tháng {mLabel}</div>
            <div className="mbkpi-net">{pay ? fmtVND(pay.netPay) : '—'}</div>
            <div className="small" style={{ color: 'var(--ok)' }}>Thực lãnh{pay && !pay.locked ? ' (tạm tính)' : ''}</div>
          </div>
          <button className="btn ghost sm" onClick={onOpenSalary} style={{ whiteSpace: 'nowrap' }}>Chi tiết lương ›</button>
        </div>
      </div>

      {/* Cấu thành lương */}
      <div className="card mbkpi-card mbkpi-breakdown">
        <div className="row between"><span>Lương cơ bản</span><b className="mono">{pay ? fmtVND(pay.baseSalary) : '—'}</b></div>
        <div className="row between"><span>Hoa hồng</span><b className="mono">{pay ? fmtVND(commission) : '—'}</b></div>
        <div className="row between"><span>Thưởng / phạt</span>
          <b className="mono" style={{ color: pay && pay.adjustTotal < 0 ? 'var(--danger)' : 'var(--ok)' }}>
            {pay ? `${pay.adjustTotal >= 0 ? '+' : '−'} ${fmtVND(Math.abs(pay.adjustTotal || 0))}` : '—'}
          </b>
        </div>
      </div>
    </div>
  );
}
